// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3spot","col":"styles_col__3HgCh"};